module.exports = __webpack_public_path__ + "img/05.d98c0c94.jpg";